import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

export const workoutFeedback = createSlice({
    name: "workoutSetupData",
    initialState,
    reducers: {
        hydrateWorkoutFeedback: (state, action) => {
            return action.payload ?? [];
        },

        createWorkoutFeedbackData: (state, { payload }) => {
            const {
                exerciseNameLocal,
                difficultyExercise,
                exerciseName,
                feelingEstimation,
                workoutEstimation,
                heartBeatsEstimation,
                isRecordedUserResponse,
                date,
            } = payload;

            const newTraining = {
                // date: "2025-02-06",
                // date: "2025-02-21",
                // date: "2025-02-13",
                // date: "2024-12-31",
                // date: "2025-01-28",
                // date: "2025-02-28",
                // date: "2025-03-02",
                // date: "2025-04-03",
                // date: "2025-04-01",
                // date: "2025-03-01",
                // date: "2025-03-19",
                date: date,
                "user-data": {
                    exerciseNameLocal: exerciseNameLocal,
                    difficultyExercise: difficultyExercise,
                    exerciseName: exerciseName,
                    feelingEstimation: feelingEstimation,
                    workoutEstimation: workoutEstimation,
                    heartBeatsEstimation: heartBeatsEstimation,
                    isRecordedUserResponse: isRecordedUserResponse,
                },
            };

            const index = state.findIndex(
                (item) => item.date === newTraining.date,
            );
            index === -1
                ? state.push(newTraining)
                : (state[index] = newTraining);
        },
    },
});

export const { hydrateWorkoutFeedback, createWorkoutFeedbackData } =
    workoutFeedback.actions;
export default workoutFeedback.reducer;
